import type { JSX } from "react";

import { SectionTitleUnderlined } from "common/components";
import type { TopicBackLabelData } from "context/session/sessionTypes";
import { TopicSlider } from "domains/topic/components/TopicSlider";
import type { Topic } from "entities/topics/types";

type TopicSectionProps = {
  isPending?: boolean;
  seeAllLink?: JSX.Element;
  title: string | JSX.Element;
  titleDataTestId?: string;
  topicBack: TopicBackLabelData;
  topics: Topic[];
};

export const TopicSection = ({
  isPending = false,
  seeAllLink,
  title,
  titleDataTestId,
  topicBack,
  topics,
}: TopicSectionProps) => (
  <>
    <SectionTitleUnderlined isLoading={isPending} dataTestId={titleDataTestId} rightElement={seeAllLink}>
      {title}
    </SectionTitleUnderlined>
    <TopicSlider topicBack={topicBack} topics={topics} />
  </>
);
